import React from 'react';
import type { FormikValues } from 'formik';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import Grid from '~/components/core/Atomic/Grid/Grid';
import SwitchFormik from '~/components/core/Formik/SwitchFormik';
import BaseConfigurationSection from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/Sections/BaseConfigurationSection';
import ConfiguredFieldsSection from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/Sections/ConfiguredFieldsSection';

import copies from '../copies.json';

import SystemFieldsSection from './SystemFieldsSection/SystemFieldsSection';

const ID_PREFIX = 'configuration.policy.covered_objects';

const getSystemFields = (coveredObject: { desc: string; type: string }) => {
  const displayNameField = {
    id: 'display_name',
    desc: coveredObject?.desc?.replace('Covered ', ''),
    type: 'string',
    mandatory: true,
    active: true,
  };
  const contactField = {
    id: 'contact_id',
    desc: coveredObject?.type === 'property' ? 'Owner' : 'Name',
    type: 'contact',
    mandatory: true,
    active: true,
  };
  return coveredObject?.type === 'property' ? [displayNameField, contactField] : [contactField];
};

interface GeneralCoveredObjectSectionProps {
  coveredObjectIndex: number;
}

const GeneralCoveredObjectSection: React.FC<GeneralCoveredObjectSectionProps> = ({ coveredObjectIndex }) => {
  const { values } = useFormikContext<FormikValues>();
  const coveredObject = get(values, `configuration.policy.covered_objects[${coveredObjectIndex}]`, {});

  return (
    <BaseConfigurationSection
      title={coveredObject.desc}
      subtitle={`Key: ${coveredObject.id}`}
      isSection
      noGridContainer
    >
      {/* noGridContainer above means children are rendered bare, so the toggle brings its own. */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SwitchFormik
            id={`${ID_PREFIX}.[${coveredObjectIndex}].allow_not_listed_on_policy`}
            label={copies.allow_not_listed_on_policy_label}
            hideErrorGap
          />
        </Grid>
      </Grid>
      <SystemFieldsSection fields={getSystemFields(coveredObject)} subtitle={copies.system_fields_subtitle} />
      <ConfiguredFieldsSection
        fieldId={`${ID_PREFIX}.[${coveredObjectIndex}].configured_fields`}
        disabled={false}
        disableCategories
        subtitle={copies.additional_fields_note}
        withShowInInvolved
        withIncludeInManagementPreview
        withDndReorder
      />
    </BaseConfigurationSection>
  );
};

export default GeneralCoveredObjectSection;
